export const EMAILJS_CONFIG = {
    publicKey: "GtXN6zby8GYkD7ICU",
    serviceId: "service_oxwu9mr",
    templateId: "template_li5ekd9",
    replyTemplateId: "template_htez9ol",
}